<template>
    <div class="lang">
        <div class="info">
            <h3 class="bullet01">Олон улсын эмчилгээний төв</h3>
            <p class="depth">
                И-Хуа Эмэгтэйчүүдийн их сургуулийн Анагаах ухааны төвийн Олон улсын эмчилгээний төв нь олон орны үйлчлүүлэгчдэд өвчтөнд ээлтэй эрүүл мэндийн цогц үйлчилгээг үзүүлдэг. Бидний БНСУ дахь АНУ-ын зэвсэгт хүчин, ОУ-ын SOS байгууллага, Абу Дабигийн Эрүүл мэндийн газар зэрэг гадаадын засгийн газрын байгууллага болон дэлхий даяар үйл ажиллагаа явуулж буй олон арван эрүүл мэндийн байгууллагатай тогтоосон урт хугацааны харилцаа нь олон орноос зорин ирсэн үйлчлүүлэгчиддээ илүү сайн үйлчилгээ үзүүлэхэд түлхэц болдог үнэт баялгийн маань нэг юм. <br>
                Манай эмнэлэг яаралтай тусламж, амбулаторын үзлэг эмчилгээ, хэвтүүлэн эмчлэх үйлчилгээ үзүүлж, эрүүл мэндийг дэмжих урьдчилан сэргийлэх үзлэг оношилгоо хийдэг. Манай эмнэлгээр үйлчлүүлдэг дэлхийн өнцөг булан бүрээс ирсэн бүх эмчлүүлэгч болон тэдний гэр бүлд хамгийн дээд зэрэглэлийн эрүүл мэндийн үйлчилгээг хүргэхийн тулд бид байнга шинийг эрэлхийлж чармайн ажиллаж байна.
            </p>
        </div>
        <div class="info">
            <h3 class="bullet01">Консьерж болон координатрын үйлчилгээ</h3>
            <p class="depth">
                И-хуа Эмэгтэйчүүдийн их сургуулийн Анагаах ухааны төв нь 60 гаруй улс орны иргэдэд үйлчилж байна. Манай эмнэлэгт өндөр боловсрол эзэмшиж арвин туршлага хуримтлуулсан эмч мэргэжилтэн, англи, хятад, орос, араб хэлээр ярьдаг координаторууд ажилладаг. Бид онцгой зочиддоо гойд тохь тухыг бэлэглэх консьерж, ВИП өрөөг ажиллуулж, үйлчлүүлэгчдийнхээ өвөрмөц онцлог соёлд тохирсон хөтөлбөрийг хэрэгжүүлдэг.
            </p>
        </div>
        <div class="info">
            <h3 class="bullet01">Нэг цэгийн үйлчилгээ</h3>
            <p class="depth">
                Гадаад үйлчлүүлэгчдийн хувьд цаг алт байдгийг бид ойлгодог учир нэг удаагийн ирэлтээр зөвлөгөө өгч шинжилгээг нь хийдэг. Мөн түүнчлэн бид гадаадын үйлчлүүлэгчдээ бүртгэл хийлгэхээс эхлээд байрлах газар захиалах, эмнэлэгээс гарах болон онгоцны буудлаас ирж очиход хүртэл алхам тутамд нь туслалцаа үзүүлэх координаторын үйлчилгээ үзүүлдэг.
            </p>
        </div>
        <div class="info">
            <h3 class="bullet01">Цагийн хуваарь(Олон улсын эмчилгээний төв)</h3>
            <div class="info information-call__box">
                <div class="information-call__img"><img alt="" src="/resource/icon/phon.png">
                    <h4 class="pc-none">Ажлын өдрүүдэд : 09:00 ~ 17:00</h4>
                </div>

                <div class="information-call__text">
                    <h4 class="mo-none">Ажлын өдрүүдэд : 09:00 ~ 17:00</h4>

                    <p>
                        Бямба гарагт: Амарна <br>
                        Ням, нийтийн амралтын өдрүүд : 1 давхарт байрлах түргэн тусламжийн төвд хандаарай
                    </p>
                </div>
            </div>
        </div>
        <div class="info">
            <h3 class="bullet01">Байршил(Олон улсын эмчилгээний төв)</h3>
            <h4 class="bullet02">Олон улсын эмчилгээний төв нь 1-р давхарт байрладаг.</h4>
            <div class="layout mt20">
                <div class="layout__inner">
                    <div class="layout__info">
                        <div class="layout__store">
                            <h4 class="layout__store-tit">1F</h4>
                            <ul class="layout__store-list">
                                <!--v-if--><!--v-if--><!--v-if--><!--v-if--><!--v-if--><!--v-if--><!--v-if--><!--v-if--><!--v-if--><!--v-if--><!--v-if-->
                                <li class="layout__store-item active">
                                    <button type="button">ДҮРС ОНОШИЛГООНЫ ТАСАГ</button>
                                </li><!--v-if--><!--v-if-->
                                
                            </ul>
                        </div>
                        <div class="layout__map">
                            <!-- <h3 class="tit"><span class="num">{{current.floor}}</span><span class="circle"></span></h3> -->
                            <div class="pin active" style="bottom: 27%;right:calc(9.7% - 26px)"><img
                                    src="/resource/icon/pin.svg" alt="이미지" class="active"></div><img
                                src="/displayFile.do?name=20241128.1527.25.184.jpg" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>